export default {"src":"/_next/static/media/rechtsanwalt-logo.f83f46da.svg","height":170,"width":646,"blurWidth":0,"blurHeight":0};